<template>
  <div :class="$style['pt-customer-of-system-table']">
      <wt-paged-table  :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table" :isAddPageToRouter="true" :isOutside="isOutside"
      :refresh="false">
          <wt-table :labels="tableLabels" :list="tableData">
              <slot/>
          </wt-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-customer-of-system-table'

export default {
  name: 'pt-customer-of-system-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    },
    reload () {
      this.$refs.table.load()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-customer-of-system-table{

}
</style>
